import Application from './Application';
import Underwriting from './Underwriting';
import Loan from './Loan';
import Account from './Account';
import Product from './Product';
import { default as BrokerDetails } from './BrokerDetails';

const exportObject = {
  Application,
  Underwriting,
  Loan,
  Account,
  Product,
  BrokerDetails,
};

export default exportObject;
